import _sfc_main from "./MultiStreamViewPC.vue2.mjs";
/* empty css                        */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { attrs: { "id": "streamContainer" } }, [_c(_setup.StreamList, { attrs: { "streamInfoList": _setup.streamInfoList, "column": _setup.column, "row": _setup.row, "streamPlayMode": _setup.StreamPlayMode.PLAY_IN_VISIBLE, "streamPlayQuality": _setup.StreamPlayQuality.Default, "aspect-ratio": "16:9" }, on: { "stream-view-dblclick": _setup.handleStreamDblclick } }), _setup.showTurnPageControl && _setup.showRoomTool ? _c("div", { staticClass: "turn-page-container" }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.showTurnPageLeftArrow, expression: "showTurnPageLeftArrow" }], staticClass: "turn-page-arrow-container left-container", on: { "click": _setup.handleTurnPageLeft } }, [_c(_setup.SvgIcon, { attrs: { "icon": _setup.ArrowStrokeTurnPageIcon } })], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.showTurnPageRightArrow, expression: "showTurnPageRightArrow" }], staticClass: "turn-page-arrow-container right-container", on: { "click": _setup.handleTurnPageRight } }, [_c(_setup.SvgIcon, { staticClass: "turn-page-right", attrs: { "icon": _setup.ArrowStrokeTurnPageIcon } })], 1)]) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "3b2db5bb"
);
const MultiStreamViewPC = __component__.exports;
export {
  MultiStreamViewPC as default
};
